import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import React, { Component, useEffect, useState }  from 'react';
import {Tab, Row, Col, Nav, Accordion, Tabs} from "react-bootstrap";
import {sleep} from "./AddBrandModal";
import {Trash} from "react-feather";
import Moment from "moment";
import { Spinner } from 'reactstrap';
import axios from 'axios';
import { getMarket, apiFetch, API } from "../../services/api";

function UpdateProductSponsoringModal({isOpen, closeModal, selectedProductSponsoring, availableMerchands}) {
    const [productSponsoring, setProductSponsoring] = useState(selectedProductSponsoring);
    const [selectedHeadCategory, setSelectedHeadCategory] = useState("/products/shoes");
    const [availableProducts, setAvailableProducts] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [selectedProductDeclinations, setSelectedProductDeclinations] = useState(selectedProductSponsoring && selectedProductSponsoring.declinations ? selectedProductSponsoring.declinations : null);

    const [beginDate, setBeginDate] = useState(selectedProductSponsoring && selectedProductSponsoring.beginDate ? selectedProductSponsoring.beginDate : null);
    const [endDate, setEndDate] = useState(selectedProductSponsoring && selectedProductSponsoring.endDate ? selectedProductSponsoring.endDate : null);

    const [loading, setLoading] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);

    const [loadingSelectedProduct, setLoadingSelectedProduct] = useState(false);
    const [newDeclinaisonMerchandName, setNewDeclinaisonMerchandName] = useState("");
    const [newDeclinaisonMerchandUrl, setNewDeclinaisonMerchandUrl] = useState("");

    const addNewMerchandDeclinaison = (declinaiton, newDeclinaisonMerchandName, declinations) => {
        declinaiton.retailerSponsoring = {
            retailerName: newDeclinaisonMerchandName, 
            url: newDeclinaisonMerchandUrl,
        }

        var outputDeclinations = []
        if (declinations && declinations.length > 0){
            declinations.map(d => {
                if (d.reference == declinaiton.reference){
                    outputDeclinations.push(declinaiton)
                } else {
                    outputDeclinations.push(d)
                }
            })
        }
        setSelectedProduct({...selectedProduct, declinations: outputDeclinations})
        setSelectedProductDeclinations(outputDeclinations)

        setNewDeclinaisonMerchandName("")
        setNewDeclinaisonMerchandUrl("")
    }

    const uploadFirstImg = (e, declinaiton) => {
        const file = e.target.files[0]
        if (!file) return

        const fileName = file.name
        const reader = new FileReader()

        reader.readAsDataURL(file)

        reader.onload = () => {
            fetch('https://back-api.therunningcollective.fr/upload-file', {
                method: 'PUT',
                headers: {
                    'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    blob: reader.result,
                    fileName: "products/" + fileName
                })
            })
                .then((res) => res.json())
                .then((result) => {
                    if (!declinaiton.retailerSponsoring) {
                        declinaiton.retailerSponsoring = {}
                    }
                    declinaiton.retailerSponsoring.imageLink = result.message

                    const declinations = selectedProductDeclinations || []
                    const outputDeclinations = declinations.map(d =>
                        d.reference == declinaiton.reference ? declinaiton : d
                    )

                    setSelectedProduct({ ...selectedProduct, declinations: outputDeclinations })
                    setSelectedProductDeclinations(outputDeclinations)
                })
                .catch((err) => console.log(err))
        }
    }

    const removeMerchandDeclinaison = (declinaiton, name, declinations) => {
        declinaiton.retailerSponsoring = {}

        var outputDeclinations = []
        if (declinations && declinations.length > 0){
            declinations.map(d => {
                if (d.reference == declinaiton.reference){
                    outputDeclinations.push(declinaiton)
                } else {
                    outputDeclinations.push(d)
                }
            })
        }
        setSelectedProduct({...selectedProduct, declinations: outputDeclinations})
        setSelectedProductDeclinations(outputDeclinations)

        setNewDeclinaisonMerchandName("")
        setNewDeclinaisonMerchandUrl("")
    }

    const handleClose = (selectedProduct, selectedProductDeclinations) => {
        setLoadingSubmit(true)
        selectedProduct.beginDate = beginDate
        selectedProduct.endDate = endDate
        selectedProduct.declinations = selectedProductDeclinations

        console.log(selectedProduct)

        /*if (selectedProduct.declinations && selectedProduct.declinations.length > 0 && selectedProductSponsoring && 
            selectedProductSponsoring.declinations && selectedProductSponsoring.declinations.length > 0){
                var outputDeclinations = []
                var toUpdate = false
                selectedProduct.declinations.map(d => {
                    selectedProductSponsoring.declinations.map(existingD => {
                        if ((!d.retailers || d.retailers.length == 0) && (existingD.retailers && existingD.retailers.length > 0)){
                            d.retailers = existingD.retailers
                            toUpdate = true
                        } 
                    })
                    outputDeclinations.push(d)
                })
                if(toUpdate){
                    selectedProduct.declinations = outputDeclinations
                }
        } */

        selectedProduct.language = getMarket()

        apiFetch(API.products + '/product-sponsoring', {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(selectedProduct)
        })
        .then(async response =>
            await sleep(2000).then(
                () => (
                    closeModal,
                window.location.reload(false)
            )
            ),
        )
        .catch( err =>
            console.log(err)
        )
        .finally(() =>{
            setLoadingSubmit(false)
        })
    }
        

    const getProducts = (headCategory) => {
        setLoading(true);
    
        axios
        .get('https://back-products-api.therunningcollective.fr/small-products?headCategories='+headCategory+'&lang='+getMarket(), {
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            },
        })
        .then(res => {
            setAvailableProducts(res.data)
        })
        .catch( err =>
            console.log(err)
        )
        .finally(() => {
            setLoading(false)
        })
    }

    const getProduct = (slug) => {
        setLoadingSelectedProduct(true);

        axios
        .get('https://back-products-api.therunningcollective.fr/product?lang='+getMarket()+'&shortURL='+slug, {
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
            },
        })
        .then((res) => {
            setSelectedProduct(res.data);
            if(!selectedProductDeclinations || selectedProductDeclinations.length ==0){
                setSelectedProductDeclinations(res.data.declinations)
            }
        })
        .catch( err =>
            console.log(err)
        )
        .finally(() => {
            setLoadingSelectedProduct(false)
        })
    }

    useEffect(() => {
        getProducts(selectedHeadCategory)
    }, [selectedHeadCategory])

    useEffect(() => {
        if(productSponsoring && productSponsoring !== "" && typeof productSponsoring === 'string' && productSponsoring !== "[object%20Object]"){
            getProduct(productSponsoring)
        }
        if(productSponsoring && productSponsoring.shortURL && productSponsoring.shortURL !== "" && 
            typeof productSponsoring.shortURL === 'string' && productSponsoring.shortURL !== "[object%20Object]"){
            getProduct(productSponsoring.shortURL)
        }
    }, [productSponsoring])

    useEffect(() => {
        console.log(productSponsoring)
    }, [productSponsoring])

    return(
        <Modal
            show={isOpen}
            onHide={closeModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Modifier un sponsoring de produit</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                    <Row>
                        <Col sm={3}>
                            <Nav variant="pills" className="flex-column">
                                <Nav.Item>
                                    <Nav.Link eventKey="first">Informations générales</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second">Références </Nav.Link>
                                </Nav.Item>
                            </Nav>
                        </Col>
                        <Col sm={9}>
                            <Tab.Content>
                                <Tab.Pane eventKey="first">
                                    <Form.Group >
                                        <Form.Label>Catégorie parente : </Form.Label>
                                        <Form.Control
                                            as="select"
                                            custom
                                            onChange={(e) => setSelectedHeadCategory(e.target.value)}
                                            value={selectedHeadCategory}
                                        >
                                            <option value="/products/shoes">Chaussures</option>
                                            <option value="/products/spikes">Pointes</option>
                                            <option value="/products/apparel">Vêtements</option>
                                            <option value="/products/accessories">Accessoires</option>
                                            <option value="/products/electronic">Electronique</option>
                                            <option value="/products/nutrition">Nutrition</option>
                                            <option value="/products/vouchers">Carte cadeau</option>
                                        </Form.Control>
                                    </Form.Group>
                                    {
                                        loading ?
                                        <div style={{textAlign: 'center'}}>
                                            <Spinner animation="border" role="status">
                                                <span className="visually-hidden"></span>
                                            </Spinner>
                                        </div>
                                        : 
                                        <Form.Group>
                                            <Form.Label>Sélection du produit: </Form.Label>
                                            <Form.Control
                                                as="select"
                                                onChange={(e) => setProductSponsoring(e.target.value)}
                                                defaultValue={selectedProductSponsoring && selectedProductSponsoring.shortURL ? selectedProductSponsoring.shortURL : ""}
                                            >
                                                {availableProducts && availableProducts.length > 0 && availableProducts.sort((a, b) => a.name > b.name ? 1 : -1).map((product, index) =>
                                                    <option 
                                                        key={product.name}
                                                        value={product.shortURL}
                                                    >
                                                        {product.name}
                                                    </option>
                                                )}
                                            </Form.Control>
                                        </Form.Group>
                                    }
                                    <Form.Group>
                                        <Form.Label>Date de début : </Form.Label>
                                        <Form.Control key="beginDate" type="datetime-local" name="sponsoring" placeholder="Début"
                                                        defaultValue={Moment(productSponsoring.beginDate).format('YYYY-MM-DDTHH:mm').toString()}
                                                        onChange={(e) => setBeginDate(new Date(e.target.value).toISOString())}
                                        />
                                    </Form.Group>
                                    <Form.Group>
                                        <Form.Label>Date de fin : </Form.Label>
                                        <Form.Control key="endDate" type="datetime-local" name="sponsoring" placeholder="Fin"
                                                        defaultValue={Moment(productSponsoring.endDate).format('YYYY-MM-DDTHH:mm').toString()}
                                                        onChange={(e) => setEndDate(new Date(e.target.value).toISOString())}
                                        />
                                    </Form.Group>
                                </Tab.Pane>
                                <Tab.Pane eventKey="second">
                                    <Tabs id="uncontrolled-tab-example">
                                        { 
                                            selectedProductSponsoring && selectedProductSponsoring.declinations && selectedProductSponsoring.declinations.length > 0 ?
                                            selectedProductSponsoring.declinations.map((declinaiton, index) => (
                                            <Tab key={index} eventKey={index} title={index}>
                                                <Form.Group >
                                                    <Form.Label>Référence : </Form.Label>
                                                    <Form.Control disabled type="text" onChange={(e) => declinaiton.reference = e.target.value} defaultValue={declinaiton.reference} placeholder="123456"/>
                                                </Form.Group>
                                                <Form.Group >
                                                    <Form.Label>Image de couverture : </Form.Label>
                                                    <Form.File
                                                        id="custom-first-img-translate-html"
                                                        label="Ajouter un image"
                                                        data-browse="Ajouter"
                                                        custom
                                                        disabled
                                                    />
                                                    {declinaiton.firstImg ?
                                                            <img className="imgToDisplay" alt="Couverture actuelle" src={declinaiton.firstImg}/>
                                                        :
                                                        null
                                                    }
                                                </Form.Group>
                                                <Form.Group >
                                                    <Form.Label>Vendeurs : </Form.Label>
                                                    <Accordion>
                                                        <Form>
                                                            <Form.Group as={Row} key={declinaiton.retailerSponsoring ? declinaiton.retailerSponsoring.retailerName : ""}>
                                                                <Form.Label column sm="4">
                                                                    <Form.Control
                                                                        as="select"
                                                                        defaultValue={declinaiton.retailerSponsoring ? declinaiton.retailerSponsoring.retailerName : ""}
                                                                        onChange={(e) => declinaiton.retailerSponsoring.retailerName = e.target.value}
                                                                    >
                                                                        <option value={""} key={"..."}>...</option>
                                                                        {availableMerchands.map(merchand =>
                                                                            <option value={merchand.name} key={merchand.name}>{merchand.name}</option>
                                                                        )}
                                                                    </Form.Control>
                                                                </Form.Label>
                                                                <Col sm="7" className="retailerUrl">
                                                                    <Form.Control type="text" onChange={(e) => declinaiton.retailerSponsoring.url = e.target.value} defaultValue={declinaiton.retailerSponsoring ? declinaiton.retailerSponsoring.url : ""} placeholder="https://....."/>
                                                                </Col>
                                                            </Form.Group>
                                                        </Form>
                                                    </Accordion>
                                                    <Form.Label>Image sponsorisée : </Form.Label>
                                                    <Form.File
                                                        id="custom-first-img-translate-html"
                                                        label="Ajouter un image"
                                                        data-browse="Ajouter"
                                                        onChange= {(e) => {uploadFirstImg(e, declinaiton)}}
                                                        custom
                                                    />
                                                    {declinaiton.retailerSponsoring ?
                                                            <img className="imgToDisplay" alt="Couverture actuelle" src={declinaiton.retailerSponsoring.imageLink}/>
                                                        :
                                                        null
                                                    }
                                                </Form.Group>
                                            </Tab>))
                                            : 
                                            selectedProductDeclinations &&  selectedProductDeclinations.length > 0
                                            && selectedProductDeclinations.map((declinaiton, index) => (
                                            <Tab key={index} eventKey={index} title={index}>
                                                <Form.Group >
                                                    <Form.Label>Référence : </Form.Label>
                                                    <Form.Control disabled type="text" onChange={(e) => declinaiton.reference = e.target.value} defaultValue={declinaiton.reference} placeholder="123456"/>
                                                </Form.Group>
                                                <Form.Group >
                                                    <Form.Label>Image de couverture : </Form.Label>
                                                    <Form.File
                                                        id="custom-first-img-translate-html"
                                                        label="Ajouter un image"
                                                        data-browse="Ajouter"
                                                        custom
                                                        disabled
                                                    />
                                                    {declinaiton.firstImg ?
                                                            <img className="imgToDisplay" alt="Couverture actuelle" src={declinaiton.firstImg}/>
                                                        :
                                                        null
                                                    }
                                                </Form.Group>
                                                <Form.Group >
                                                    <Form.Label>Vendeurs : </Form.Label>
                                                    <Accordion>
                                                        <Form>
                                                            <Form.Group as={Row} key={declinaiton.retailerSponsoring ? declinaiton.retailerSponsoring.retailerName : ""}>
                                                                <Form.Label column sm="4">
                                                                    <Form.Control
                                                                        as="select"
                                                                        defaultValue={declinaiton.retailerSponsoring ? declinaiton.retailerSponsoring.retailerName : ""}
                                                                        onChange={(e) => declinaiton.retailerSponsoring.retailerName = e.target.value}
                                                                    >
                                                                        <option value={""} key={"..."}>...</option>
                                                                        {availableMerchands.map(merchand =>
                                                                            <option value={merchand.name} key={merchand.name}>{merchand.name}</option>
                                                                        )}
                                                                    </Form.Control>
                                                                </Form.Label>
                                                                <Col sm="7" className="retailerUrl">
                                                                    <Form.Control type="text" onChange={(e) => declinaiton.retailerSponsoring.url = e.target.value} defaultValue={declinaiton.retailerSponsoring ? declinaiton.retailerSponsoring.url : ""} placeholder="https://....."/>
                                                                </Col>
                                                            </Form.Group>
                                                        </Form>
                                                    </Accordion>
                                                </Form.Group>
                                            </Tab>
                                        ))
                                        }
                                    </Tabs>
                                </Tab.Pane>
                            </Tab.Content>
                        </Col>
                    </Row>
                </Tab.Container>
            </Modal.Body>
            <Modal.Footer>
                {
                    loadingSubmit ?
                        <div style={{textAlign: 'center'}}>
                            <Spinner animation="border" role="status">
                                <span className="visually-hidden"></span>
                            </Spinner>
                        </div>
                    : 
                    <>
                        <Button variant="secondary" type="cancel" onClick={() => closeModal()}>
                            Annuler
                        </Button>
                        <Button variant="primary" type="submit" onClick={() => handleClose(selectedProduct, selectedProductDeclinations)}>
                            Valider
                        </Button>
                    </>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default UpdateProductSponsoringModal;

function getSelectedItems(items){
    var arrayToReturn = []

    if (items) {
        items.map(item => (
            arrayToReturn.push(item.name)
        ))
    }

    return arrayToReturn
}